var map = {
	"./bg_default.png": "8069",
	"./delay-icon.png": "fbff",
	"./luck_bag.png": "6bd7",
	"./mall_reward_push.png": "c97e",
	"./no-create.png": "f116",
	"./no-search.png": "8c45",
	"./null.png": "6dbc",
	"./phone.png": "04dd",
	"./phone_wap.png": "29e6",
	"./playback_expire.png": "cb40",
	"./red_packet_open.png": "54b6",
	"./ribbon/ribbon-1.png": "115d",
	"./ribbon/ribbon-2.png": "9e2e",
	"./ribbon/ribbon-3.png": "2575",
	"./ribbon/ribbon-4.png": "fe3f",
	"./ribbon/ribbon-5.png": "d781",
	"./ribbon/ribbon-6.png": "21e1",
	"./videoFailed.png": "db91",
	"./wap/file/audio.png": "259f",
	"./wap/file/csv.png": "5d23",
	"./wap/file/excel.png": "177d",
	"./wap/file/img.png": "715d",
	"./wap/file/pdf.png": "f78c",
	"./wap/file/ppt.png": "2036",
	"./wap/file/video.png": "1e4c",
	"./wap/file/word.png": "02a8",
	"./wap/file/zip.png": "a266",
	"./wap/theme/default_blue.png": "5330",
	"./wap/theme/default_golden.png": "9bf29",
	"./wap/theme/default_red.png": "9270"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7930";